<template>

  <b-container fluid style="margin-bottom: 50px;">
  </b-container>

</template>

<script>

export default {
  name: "Pages",
}
</script>

<style scoped>

</style>